import styled from "@emotion/styled";
import { RelayCommand, theme } from "Application";
import { Box, Button } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import { ThemedEditSelect } from "Styles/ThemedPrimitives/Style1/ThemeEditSelect";
import React from "react";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { Files } from "Views/Students/Student/StudentReports/Files/Files";

const Container = styled.div`
    padding: 25px 20px;
`;

const Footer = styled.div``;

const ButtonGroup = styled.div`
    padding: 30px 0 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px 30px;
    Button {
        width: 100%;
        margin-bottom: 0;
        height: 40px;
        border-radius: 5px;
    }
`;

const StyledDialog = styled.dialog`
    max-width: 400px;
    width: calc(100% - 50px);
    padding: 0;
    background: ${theme.palette.common.white};
    box-shadow: 0 0 5px rgba(101, 110, 119, 0.2);
    border: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:focus {
        border: none;
        outline: none;
    }

    &::backdrop {
        background: rgba(224, 228, 232, 0.9);
        animation: 0.4s ease fade;
    }

    &[open] {
        animation: 0.2s linear slidein;
    }

    @keyframes slidein {
        from {
            transform: translate3d(0, 5px, 0) translate(-50%, -50%);
        }
        to {
            transform: translate3d(0, 0, 0) translate(-50%, -50%);
        }
    }

    @keyframes fade {
        from {
            opacity: 0.3;
        }
        to {
            opacity: 1;
        }
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fcd21d;
    padding: 12px 20px;
    font: normal normal bold 18px/24px Open Sans;
    letter-spacing: 0px;
    color: #000000;
    font-family: OpenSans-CondBold;
    button {
        width: auto !important;
        height: auto !important;
        min-height: auto;
    }
`;

const CreateBox = styled(Box)`
    & > div .isButtonDisable {
        cursor: default;
        color: #495057;
        background-color: #e9ecef;
    }
`;

export interface IProps {
    viewModel: IStudentSessionReportViewModel;
}

export const SessionReportUploadModal: React.FC<IProps> = ({ viewModel }) => {
    const modalCloseCommand = new RelayCommand(() => {
        viewModel.dismissUploadModal();
    });

    return (
        <StyledDialog open={true}>
            <Header>
                Upload session doc/photo <CloseIcon onClick={() => modalCloseCommand.execute()} />
            </Header>
            <Container>
                <Box mb="30px">
                    <ThemedEditSelect
                        displayName={"Category"}
                        placeholder={"Please select"}
                        command={viewModel.updateDocumentCategoryCommand}
                        options={viewModel.getDocumentCategory}
                        value={() => viewModel.getValue("documentCategoryId")}
                        validationMessage={() => viewModel.getError("documentCategoryId")}
                    />
                </Box>
                <Box>
                    <Files viewModel={viewModel.filesViewModel} />
                </Box>
                <Footer>
                    <CreateBox>
                        <ButtonGroup>
                            <Button
                                command={viewModel.uploadStudentReportCommand}
                                className={viewModel.apiClient.IsBusy ? "isButtonDisable" : ""}
                                displayName={"UPLOAD"}
                                paletteColor="primary"
                            />
                            <Button command={modalCloseCommand} className={viewModel.apiClient.IsBusy ? "isButtonDisable" : ""} displayName={"CANCEL"} paletteColor="secondary" />
                        </ButtonGroup>
                    </CreateBox>
                </Footer>
            </Container>
        </StyledDialog>
    );
};
